import React, { useEffect, useState } from 'react';
import { BellIcon, XIcon } from 'lucide-react';

const NotificationCard = ({ notification, onClick, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Animate in
    setIsVisible(true);

    // Set a timer to automatically close the card after 8 seconds
    const timer = setTimeout(() => {
      handleClose();
    }, 8000);

    return () => {
      clearTimeout(timer);
    };
  }, [notification.id]); // Re-trigger when the notification changes

  const handleClose = () => {
    setIsVisible(false);
    // Allow for fade-out animation before calling the parent onClose
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleClick = () => {
    onClick();
    handleClose();
  };

  return (
    <div
      className={`fixed top-4 right-4 z-[9999] w-80 bg-white rounded-xl shadow-2xl p-4 border-l-4 border-green-aqua transform transition-all duration-300 ease-in-out ${
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-16 opacity-0 pointer-events-none'
      }`}
    >
      <div className="flex items-start gap-3">
        {/* Icon */}
        <div className="flex flex-shrink-0 justify-center items-center w-10 h-10 bg-green-aqua/10 rounded-full">
          <BellIcon className="w-5 h-5 text-green-aqua" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0 cursor-pointer" onClick={handleClick}>
          <p className="text-sm font-bold leading-tight text-gray-800">{notification.title}</p>
          <p className="text-sm leading-relaxed text-gray-600 mt-1 line-clamp-2">{notification.message}</p>
        </div>

        {/* Close Button */}
        <button
          onClick={handleClose}
          className="flex flex-shrink-0 justify-center items-center w-6 h-6 mt-0.5 text-gray-400 rounded-full transition-all duration-200 hover:text-gray-600 hover:bg-gray-100"
          aria-label="Cerrar notificación"
        >
          <XIcon className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default NotificationCard; 